import * as TypeGraphQL from "type-graphql";
export var UserScalarFieldEnum;
(function (UserScalarFieldEnum) {
    UserScalarFieldEnum["id"] = "id";
    UserScalarFieldEnum["name"] = "name";
    UserScalarFieldEnum["email"] = "email";
    UserScalarFieldEnum["emailVerified"] = "emailVerified";
    UserScalarFieldEnum["image"] = "image";
    UserScalarFieldEnum["createdAt"] = "createdAt";
    UserScalarFieldEnum["updatedAt"] = "updatedAt";
    UserScalarFieldEnum["role"] = "role";
    UserScalarFieldEnum["bio"] = "bio";
    UserScalarFieldEnum["jobTitle"] = "jobTitle";
    UserScalarFieldEnum["currentAccount"] = "currentAccount";
    UserScalarFieldEnum["customerId"] = "customerId";
    UserScalarFieldEnum["plan"] = "plan";
    UserScalarFieldEnum["openaiAPIKey"] = "openaiAPIKey";
    UserScalarFieldEnum["openaiModel"] = "openaiModel";
})(UserScalarFieldEnum || (UserScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(UserScalarFieldEnum, {
    name: "UserScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=UserScalarFieldEnum.js.map